import { SelectFieldFilterGroup } from "@/app/components/filters/SelectFieldFilterGroup";
import { ISelectFieldOption } from "@/app/fields/types";
import { splitOptionLevels } from "@/app/utils/splitOptionLevels";
import { Accordion, Checkbox, Stack } from "@chakra-ui/react";
import { useState } from "react";

export function SelectFieldFilterOptions({
  options,
  values,
  setValues,
  isDisabled,
}: {
  options: ISelectFieldOption[];
  values: string[];
  setValues: (v: string[]) => void;
  isDisabled: boolean;
}) {
  const groups = splitOptionLevels(options);
  const [accordionIndex, setAccordionIndex] = useState<number[]>(
    groups
      .map(
        ({ _options }) =>
          _options.filter((option) => values.includes(option.value)).length > 0
      )
      .map((applied, index) => (applied ? index : -1))
      .filter((applied) => applied > -1)
  );
  return (
    <Stack spacing={2}>
      {groups.length > 1 ? (
        <Accordion
          mx={-4}
          mt={-1}
          allowMultiple={true}
          onChange={(updated: number[]) => setAccordionIndex(updated)}
          index={accordionIndex}
        >
          {groups.map(({ label, _options }) => (
            <SelectFieldFilterGroup
              isDisabled={isDisabled}
              key={label}
              options={_options}
              values={values}
              setValues={setValues}
              label={label}
            />
          ))}
        </Accordion>
      ) : (
        options.map((option) => (
          <Checkbox
            isDisabled={isDisabled}
            key={option.value}
            isChecked={values.includes(option.value)}
            onChange={() =>
              setValues(
                values.includes(option.value)
                  ? values.filter((v) => v !== option.value)
                  : [...values, option.value]
              )
            }
          >
            {option.label}
          </Checkbox>
        ))
      )}
    </Stack>
  );
}
